// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetResponse, PostUploadData, PostUploadResponse, DeleteDeleteByFileNameData, DeleteDeleteByFileNameResponse, PostFrontAuthTestLoginData, PostFrontAuthTestLoginResponse, PostFrontAuthLoginData, PostFrontAuthLoginResponse, PostFrontAuthLogoutResponse, PostFrontAuthTelegramLoginData, PostFrontAuthTelegramLoginResponse, PostFrontAuthRegisterData, PostFrontAuthRegisterResponse, GetFrontAuthProfileResponse, GetFrontMissionData, GetFrontMissionResponse, GetFrontMissionUserMissionsData, GetFrontMissionUserMissionsResponse, GetV2FrontMissionData, GetV2FrontMissionResponse, GetFrontBrandData, GetFrontBrandResponse, GetV2FrontBrandData, GetV2FrontBrandResponse, GetFrontJackpotData, GetFrontJackpotResponse, GetFrontJackpotStatsData, GetFrontJackpotStatsResponse, GetFrontJackpotByJackpotIdData, GetFrontJackpotByJackpotIdResponse, GetFrontJackpotByJackpotIdTestimonialsData, GetFrontJackpotByJackpotIdTestimonialsResponse, GetFrontJackpotByJackpotIdWinnersData, GetFrontJackpotByJackpotIdWinnersResponse, GetFrontLocaleResponse, GetFrontTicketResponse, GetFrontTicketOffersData, GetFrontTicketOffersResponse, GetFrontTicketStatsData, GetFrontTicketStatsResponse, GetFrontLeaderboardWinnersData, GetFrontLeaderboardWinnersResponse, GetFrontLeaderboardData, GetFrontLeaderboardResponse, GetFrontLeaderboardUserLeaderboardData, GetFrontLeaderboardUserLeaderboardResponse, GetV2FrontLeaderboardData, GetV2FrontLeaderboardResponse, PostFrontWalletConnectData, PostFrontWalletConnectResponse, PostFrontWalletVerifyData, PostFrontWalletVerifyResponse, PostFrontWalletDisconnectResponse, GetFrontCurrencyRateData, GetFrontCurrencyRateResponse, GetFrontUserTicketBalanceResponse, GetFrontUserTicketTicketBalanceByTicketIdData, GetFrontUserTicketTicketBalanceByTicketIdResponse, GetV2FrontUserTicketBalanceData, GetV2FrontUserTicketBalanceResponse, GetV2FrontUserTicketTicketBalanceByTicketIdData, GetV2FrontUserTicketTicketBalanceByTicketIdResponse, GetFrontUserBalanceBalanceResponse, GetFrontUserReferralStatsByTimeframeData, GetFrontUserReferralStatsByTimeframeResponse, GetFrontCmsData, GetFrontCmsResponse, GetFrontCmsSitemapData, GetFrontCmsSitemapResponse, GetFrontFaqData, GetFrontFaqResponse, GetFrontI18NData, GetFrontI18NResponse, GetV2FrontI18NData, GetV2FrontI18NResponse, PostFrontPurchaseSinglePurchaseData, PostFrontPurchaseSinglePurchaseResponse, GetFrontStatsPlatformStatsData, GetFrontStatsPlatformStatsResponse, GetFrontWinnersData, GetFrontWinnersResponse, GetAdminBrandResponse, PostAdminBrandData, PostAdminBrandResponse, GetAdminBrandByBrandIdData, GetAdminBrandByBrandIdResponse, DeleteAdminBrandByBrandIdData, DeleteAdminBrandByBrandIdResponse, PutAdminBrandByBrandIdData, PutAdminBrandByBrandIdResponse, PostAdminBrandByBrandIdEnvironmentData, PostAdminBrandByBrandIdEnvironmentResponse, PutAdminBrandByBrandIdEnvironmentData, PutAdminBrandByBrandIdEnvironmentResponse, DeleteAdminBrandByBrandIdEnvironmentData, DeleteAdminBrandByBrandIdEnvironmentResponse, GetAdminBrandByBrandIdConfigurationData, GetAdminBrandByBrandIdConfigurationResponse, PostAdminBrandByBrandIdConfigurationData, PostAdminBrandByBrandIdConfigurationResponse, GetAdminBrandConfigurationByConfigIdData, GetAdminBrandConfigurationByConfigIdResponse, PutAdminBrandByBrandIdConfigurationByConfigIdData, PutAdminBrandByBrandIdConfigurationByConfigIdResponse, DeleteAdminBrandByBrandIdConfigurationByConfigIdData, DeleteAdminBrandByBrandIdConfigurationByConfigIdResponse, PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobileData, PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobileResponse, DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobileData, DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobileResponse, PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktopData, PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktopResponse, DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktopData, DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktopResponse, PutAdminBrandByBrandIdConfigurationByConfigIdFooterLogoData, PutAdminBrandByBrandIdConfigurationByConfigIdFooterLogoResponse, DeleteAdminBrandByBrandIdConfigurationByConfigIdFooterLogoData, DeleteAdminBrandByBrandIdConfigurationByConfigIdFooterLogoResponse, PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticatedData, PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticatedResponse, DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticatedData, DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticatedResponse, PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuestData, PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuestResponse, DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuestData, DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuestResponse, PutAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListTypeData, PutAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListTypeResponse, DeleteAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListTypeData, DeleteAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListTypeResponse, GetAdminBrandByBrandIdTicketofferData, GetAdminBrandByBrandIdTicketofferResponse, PostAdminBrandByBrandIdTicketofferData, PostAdminBrandByBrandIdTicketofferResponse, GetAdminBrandByBrandIdTicketofferByTicketOfferIdData, GetAdminBrandByBrandIdTicketofferByTicketOfferIdResponse, PutAdminBrandByBrandIdTicketofferByTicketOfferIdData, PutAdminBrandByBrandIdTicketofferByTicketOfferIdResponse, DeleteAdminBrandByBrandIdTicketofferByTicketOfferIdData, DeleteAdminBrandByBrandIdTicketofferByTicketOfferIdResponse, GetAdminBrandByBrandIdTicketofferByTicketOfferIdI18NData, GetAdminBrandByBrandIdTicketofferByTicketOfferIdI18NResponse, PostAdminBrandByBrandIdTicketofferByTicketOfferIdI18NData, PostAdminBrandByBrandIdTicketofferByTicketOfferIdI18NResponse, GetAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdData, GetAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdResponse, PutAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdData, PutAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdResponse, DeleteAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdData, DeleteAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdResponse, GetAdminBrandByBrandIdTicketByBrandTicketIdData, GetAdminBrandByBrandIdTicketByBrandTicketIdResponse, PutAdminBrandByBrandIdTicketByBrandTicketIdData, PutAdminBrandByBrandIdTicketByBrandTicketIdResponse, DeleteAdminBrandByBrandIdTicketByBrandTicketIdData, DeleteAdminBrandByBrandIdTicketByBrandTicketIdResponse, PostAdminBrandByBrandIdTicketData, PostAdminBrandByBrandIdTicketResponse, GetAdminFaqData, GetAdminFaqResponse, PostAdminFaqData, PostAdminFaqResponse, GetAdminFaqByFaqIdData, GetAdminFaqByFaqIdResponse, PutAdminFaqByFaqIdData, PutAdminFaqByFaqIdResponse, DeleteAdminFaqByFaqIdData, DeleteAdminFaqByFaqIdResponse, PostAdminFaqByFaqIdBrandData, PostAdminFaqByFaqIdBrandResponse, PutAdminFaqByFaqIdBrandByBrandFaqIdData, PutAdminFaqByFaqIdBrandByBrandFaqIdResponse, DeleteAdminFaqByFaqIdBrandByBrandFaqIdData, DeleteAdminFaqByFaqIdBrandByBrandFaqIdResponse, PostAdminFaqByFaqIdI18NData, PostAdminFaqByFaqIdI18NResponse, PutAdminFaqByFaqIdI18nByI18nIdData, PutAdminFaqByFaqIdI18nByI18nIdResponse, DeleteAdminFaqByFaqIdI18nByI18nIdData, DeleteAdminFaqByFaqIdI18nByI18nIdResponse, GetAdminFaqQaByQaIdData, GetAdminFaqQaByQaIdResponse, PutAdminFaqQaByQaIdData, PutAdminFaqQaByQaIdResponse, DeleteAdminFaqQaByQaIdData, DeleteAdminFaqQaByQaIdResponse, PostAdminFaqQaData, PostAdminFaqQaResponse, GetAdminFaqByFaqIdBrandsData, GetAdminFaqByFaqIdBrandsResponse, GetAdminFaqByFaqIdQaData, GetAdminFaqByFaqIdQaResponse, GetAdminLocaleResponse, PostAdminLocaleData, PostAdminLocaleResponse, GetAdminLocaleByLocaleIdData, GetAdminLocaleByLocaleIdResponse, DeleteAdminLocaleByLocaleIdData, DeleteAdminLocaleByLocaleIdResponse, PutAdminLocaleByLocaleIdData, PutAdminLocaleByLocaleIdResponse, GetAdminJackpotTriggerJackpotsResponse, GetAdminJackpotTriggerDrawsResponse, GetAdminJackpotData, GetAdminJackpotResponse, PostAdminJackpotData, PostAdminJackpotResponse, GetAdminJackpotByJackpotIdData, GetAdminJackpotByJackpotIdResponse, PutAdminJackpotByJackpotIdData, PutAdminJackpotByJackpotIdResponse, DeleteAdminJackpotByJackpotIdData, DeleteAdminJackpotByJackpotIdResponse, PostAdminJackpotByJackpotIdPrizeData, PostAdminJackpotByJackpotIdPrizeResponse, PutAdminJackpotByJackpotIdPrizeByPrizeIdData, PutAdminJackpotByJackpotIdPrizeByPrizeIdResponse, DeleteAdminJackpotByJackpotIdPrizeByPrizeIdData, DeleteAdminJackpotByJackpotIdPrizeByPrizeIdResponse, PostAdminJackpotByJackpotIdAcceptanceConditionData, PostAdminJackpotByJackpotIdAcceptanceConditionResponse, PutAdminJackpotByJackpotIdAcceptanceConditionByConditionIdData, PutAdminJackpotByJackpotIdAcceptanceConditionByConditionIdResponse, DeleteAdminJackpotByJackpotIdAcceptanceConditionByConditionIdData, DeleteAdminJackpotByJackpotIdAcceptanceConditionByConditionIdResponse, PostAdminJackpotByJackpotIdI18NData, PostAdminJackpotByJackpotIdI18NResponse, PutAdminJackpotByJackpotIdI18nByI18nIdData, PutAdminJackpotByJackpotIdI18nByI18nIdResponse, DeleteAdminJackpotByJackpotIdI18nByI18nIdData, DeleteAdminJackpotByJackpotIdI18nByI18nIdResponse, PostAdminJackpotByJackpotIdPoolData, PostAdminJackpotByJackpotIdPoolResponse, PutAdminJackpotByJackpotIdPoolByPoolIdData, PutAdminJackpotByJackpotIdPoolByPoolIdResponse, DeleteAdminJackpotByJackpotIdPoolByPoolIdData, DeleteAdminJackpotByJackpotIdPoolByPoolIdResponse, PostAdminJackpotByJackpotIdBrandData, PostAdminJackpotByJackpotIdBrandResponse, PutAdminJackpotByJackpotIdBrandByBrandJackpotIdData, PutAdminJackpotByJackpotIdBrandByBrandJackpotIdResponse, DeleteAdminJackpotByJackpotIdBrandByBrandJackpotIdData, DeleteAdminJackpotByJackpotIdBrandByBrandJackpotIdResponse, GetAdminTicketResponse, PostAdminTicketData, PostAdminTicketResponse, GetAdminTicketByTicketIdData, GetAdminTicketByTicketIdResponse, PutAdminTicketByTicketIdData, PutAdminTicketByTicketIdResponse, DeleteAdminTicketByTicketIdData, DeleteAdminTicketByTicketIdResponse, PostAdminTicketByTicketIdI18NData, PostAdminTicketByTicketIdI18NResponse, PutAdminTicketByTicketIdI18nByI18nIdData, PutAdminTicketByTicketIdI18nByI18nIdResponse, DeleteAdminTicketByTicketIdI18nByI18nIdData, DeleteAdminTicketByTicketIdI18nByI18nIdResponse, GetAdminMissionData, GetAdminMissionResponse, PostAdminMissionData, PostAdminMissionResponse, GetAdminMissionByMissionIdData, GetAdminMissionByMissionIdResponse, PutAdminMissionByMissionIdData, PutAdminMissionByMissionIdResponse, DeleteAdminMissionByMissionIdData, DeleteAdminMissionByMissionIdResponse, PostAdminMissionByMissionIdI18NData, PostAdminMissionByMissionIdI18NResponse, PutAdminMissionByMissionIdI18nByI18nIdData, PutAdminMissionByMissionIdI18nByI18nIdResponse, DeleteAdminMissionByMissionIdI18nByI18nIdData, DeleteAdminMissionByMissionIdI18nByI18nIdResponse, PostAdminMissionByMissionIdScheduleData, PostAdminMissionByMissionIdScheduleResponse, PutAdminMissionByMissionIdScheduleByScheduleIdData, PutAdminMissionByMissionIdScheduleByScheduleIdResponse, DeleteAdminMissionByMissionIdScheduleByScheduleIdData, DeleteAdminMissionByMissionIdScheduleByScheduleIdResponse, PostAdminMissionByMissionIdTicketRewardData, PostAdminMissionByMissionIdTicketRewardResponse, PutAdminMissionByMissionIdTicketRewardByTicketRewardIdData, PutAdminMissionByMissionIdTicketRewardByTicketRewardIdResponse, DeleteAdminMissionByMissionIdTicketRewardByTicketRewardIdData, DeleteAdminMissionByMissionIdTicketRewardByTicketRewardIdResponse, PostAdminMissionByMissionIdParametersData, PostAdminMissionByMissionIdParametersResponse, PutAdminMissionByMissionIdParametersData, PutAdminMissionByMissionIdParametersResponse, DeleteAdminMissionByMissionIdParameterByParameterIdData, DeleteAdminMissionByMissionIdParameterByParameterIdResponse, GetAdminPoolResponse, PostAdminPoolData, PostAdminPoolResponse, GetAdminPoolByPoolIdData, GetAdminPoolByPoolIdResponse, PutAdminPoolByPoolIdData, PutAdminPoolByPoolIdResponse, DeleteAdminPoolByPoolIdData, DeleteAdminPoolByPoolIdResponse, PostAdminPoolByPoolIdEntriesData, PostAdminPoolByPoolIdEntriesResponse, GetAdminScheduleResponse, PostAdminScheduleData, PostAdminScheduleResponse, GetAdminScheduleByScheduleIdData, GetAdminScheduleByScheduleIdResponse, DeleteAdminScheduleByScheduleIdData, DeleteAdminScheduleByScheduleIdResponse, GetAdminIdentityResponse, PostAdminIdentityData, PostAdminIdentityResponse, GetAdminIdentityByIdentityIdData, GetAdminIdentityByIdentityIdResponse, PutAdminIdentityByIdentityIdData, PutAdminIdentityByIdentityIdResponse, DeleteAdminIdentityByIdentityIdData, DeleteAdminIdentityByIdentityIdResponse, GetAdminDrawResponse, PostAdminDrawData, PostAdminDrawResponse, GetAdminDrawByDrawIdData, GetAdminDrawByDrawIdResponse, PutAdminDrawByDrawIdData, PutAdminDrawByDrawIdResponse, DeleteAdminDrawByDrawIdData, DeleteAdminDrawByDrawIdResponse, PostAdminDrawByDrawIdEntryData, PostAdminDrawByDrawIdEntryResponse, PutAdminDrawByDrawIdEntryByEntryIdData, PutAdminDrawByDrawIdEntryByEntryIdResponse, DeleteAdminDrawByDrawIdEntryByEntryIdData, DeleteAdminDrawByDrawIdEntryByEntryIdResponse, GetTimezonesResponse, PostAdminAuthLoginData, PostAdminAuthLoginResponse, PostAdminAuthLogoutResponse, GetAdminWinnerResponse, GetAdminDebugData, GetAdminDebugResponse, PostAdminDebugPaymentResponse, GetAdminCmsResponse, PutAdminCmsData, PutAdminCmsResponse, GetAdminPagesResponse, PostAdminPagesData, PostAdminPagesResponse, GetAdminPagesByPageIdData, GetAdminPagesByPageIdResponse, PutAdminPagesByPageIdData, PutAdminPagesByPageIdResponse, DeleteAdminPagesByPageIdData, DeleteAdminPagesByPageIdResponse, PutAdminPagesByPageIdMetaOpenGraphImageListData, PutAdminPagesByPageIdMetaOpenGraphImageListResponse, DeleteAdminPagesByPageIdMetaOpenGraphImageListData, DeleteAdminPagesByPageIdMetaOpenGraphImageListResponse, PutAdminPagesByPageIdMetaTwitterImageListData, PutAdminPagesByPageIdMetaTwitterImageListResponse, DeleteAdminPagesByPageIdMetaTwitterImageListData, DeleteAdminPagesByPageIdMetaTwitterImageListResponse, GetAdminRoutesResponse, PostAdminRoutesByPageIdRoutesData, PostAdminRoutesByPageIdRoutesResponse, GetAdminRoutesByPageIdRoutesByRouteIdData, GetAdminRoutesByPageIdRoutesByRouteIdResponse, PutAdminRoutesByPageIdRoutesByRouteIdData, PutAdminRoutesByPageIdRoutesByRouteIdResponse, DeleteAdminRoutesByPageIdRoutesByRouteIdData, DeleteAdminRoutesByPageIdRoutesByRouteIdResponse, GetAdminComponenti18nByNamespaceIdComponenti18NData, GetAdminComponenti18nByNamespaceIdComponenti18NResponse, PostAdminComponenti18nByNamespaceIdComponenti18NData, PostAdminComponenti18nByNamespaceIdComponenti18NResponse, GetAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdData, GetAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdResponse, PutAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdData, PutAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdResponse, DeleteAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdData, DeleteAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdResponse, GetAdminNamespaceResponse, PostAdminNamespaceData, PostAdminNamespaceResponse, GetAdminNamespaceByNamespaceIdData, GetAdminNamespaceByNamespaceIdResponse, PutAdminNamespaceByNamespaceIdData, PutAdminNamespaceByNamespaceIdResponse, DeleteAdminNamespaceByNamespaceIdData, DeleteAdminNamespaceByNamespaceIdResponse, GetAdminTestimonialResponse, PostAdminTestimonialData, PostAdminTestimonialResponse, GetAdminTestimonialByIdData, GetAdminTestimonialByIdResponse, PutAdminTestimonialByIdData, PutAdminTestimonialByIdResponse, DeleteAdminTestimonialByIdData, DeleteAdminTestimonialByIdResponse, GetAdminDashboardRegistrationsData, GetAdminDashboardRegistrationsResponse, GetAdminDashboardActiveUsersData, GetAdminDashboardActiveUsersResponse, GetAdminDashboardMissionCompletionsData, GetAdminDashboardMissionCompletionsResponse, GetAdminDashboardMissionCompletionsPerUserData, GetAdminDashboardMissionCompletionsPerUserResponse, GetAdminToolsPurgeCacheResponse, GetAdminToolsMarkTelegramPrcUsersResponse, GetAdminToolsSyncTelegramPrcUsersResponse, PostV1BhgReverseApiApiGameLaunchData, PostV1BhgReverseApiApiGameLaunchResponse, PostV1BhgReverseApiApiGameListData, PostV1BhgReverseApiApiGameListResponse, PostV1BhgReverseApiApiGameStakeValuesResponse, PostV1BhgReverseApiApiGameBonusGiveResponse, PostV1BhgReverseApiApiGameBonusCancelResponse, PostV1BhgReverseApiApiGameRoundHistoryData, PostV1BhgReverseApiApiGameRoundHistoryResponse } from './types.gen';

export class DefaultService {
    /**
     * @returns string
     * @throws ApiError
     */
    public static get(): CancelablePromise<GetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/'
        });
    }
    
    /**
     * Upload a file
     * @param data The data for the request.
     * @param data.formData File to upload
     * @returns AwsUploadFileResponseDto File uploaded successfully
     * @throws ApiError
     */
    public static postUpload(data: PostUploadData): CancelablePromise<PostUploadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/upload',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.fileName
     * @returns unknown
     * @throws ApiError
     */
    public static deleteDeleteByFileName(data: DeleteDeleteByFileNameData): CancelablePromise<DeleteDeleteByFileNameResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/delete/{fileName}',
            path: {
                fileName: data.fileName
            }
        });
    }
    
}

export class FrontAuthService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FrontLoginResponseDto
     * @throws ApiError
     */
    public static postFrontAuthTestLogin(data: PostFrontAuthTestLoginData): CancelablePromise<PostFrontAuthTestLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/auth/test-login',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FrontLoginResponseDto
     * @throws ApiError
     */
    public static postFrontAuthLogin(data: PostFrontAuthLoginData): CancelablePromise<PostFrontAuthLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/auth/login',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static postFrontAuthLogout(): CancelablePromise<PostFrontAuthLogoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/auth/logout',
            errors: {
                500: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FrontLoginResponseDto
     * @throws ApiError
     */
    public static postFrontAuthTelegramLogin(data: PostFrontAuthTelegramLoginData): CancelablePromise<PostFrontAuthTelegramLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/auth/telegram-login',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                500: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FrontLoginResponseDto
     * @throws ApiError
     */
    public static postFrontAuthRegister(data: PostFrontAuthRegisterData): CancelablePromise<PostFrontAuthRegisterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/auth/register',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                500: ''
            }
        });
    }
    
    /**
     * @returns FrontProfileResponseDto
     * @throws ApiError
     */
    public static getFrontAuthProfile(): CancelablePromise<GetFrontAuthProfileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/auth/profile',
            errors: {
                400: '',
                500: ''
            }
        });
    }
    
}

export class FrontMissionService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @returns FrontMissionResponseDto
     * @throws ApiError
     */
    public static getFrontMission(data: GetFrontMissionData): CancelablePromise<GetFrontMissionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/mission',
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @returns FrontUserMissionResponseDto
     * @throws ApiError
     */
    public static getFrontMissionUserMissions(data: GetFrontMissionUserMissionsData): CancelablePromise<GetFrontMissionUserMissionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/mission/user-missions',
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.jackpotId
     * @param data.types
     * @returns FrontMissionV2ResponseDto
     * @throws ApiError
     */
    public static getV2FrontMission(data: GetV2FrontMissionData): CancelablePromise<GetV2FrontMissionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/front/mission',
            query: {
                hostname: data.hostname,
                language: data.language,
                jackpotId: data.jackpotId,
                types: data.types
            }
        });
    }
    
}

export class FrontBrandService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @returns FrontBrandResponseDto
     * @throws ApiError
     */
    public static getFrontBrand(data: GetFrontBrandData): CancelablePromise<GetFrontBrandResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/brand',
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @returns FrontBrandV2ResponseDto
     * @throws ApiError
     */
    public static getV2FrontBrand(data: GetV2FrontBrandData): CancelablePromise<GetV2FrontBrandResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/front/brand',
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
}

export class FrontJackpotService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @returns FrontJackpotsResponseDto
     * @throws ApiError
     */
    public static getFrontJackpot(data: GetFrontJackpotData): CancelablePromise<GetFrontJackpotResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/jackpot',
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.jackpotId
     * @returns FrontJackpotStatsResponseDto
     * @throws ApiError
     */
    public static getFrontJackpotStats(data: GetFrontJackpotStatsData): CancelablePromise<GetFrontJackpotStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/jackpot/stats',
            query: {
                hostname: data.hostname,
                language: data.language,
                jackpotId: data.jackpotId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.hostname
     * @param data.language
     * @returns FrontJackpotResponseDto
     * @throws ApiError
     */
    public static getFrontJackpotByJackpotId(data: GetFrontJackpotByJackpotIdData): CancelablePromise<GetFrontJackpotByJackpotIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/jackpot/{jackpotId}',
            path: {
                jackpotId: data.jackpotId
            },
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.hostname
     * @param data.language
     * @returns FrontJackpotTestimonialsResponseDto
     * @throws ApiError
     */
    public static getFrontJackpotByJackpotIdTestimonials(data: GetFrontJackpotByJackpotIdTestimonialsData): CancelablePromise<GetFrontJackpotByJackpotIdTestimonialsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/jackpot/{jackpotId}/testimonials',
            path: {
                jackpotId: data.jackpotId
            },
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.hostname
     * @param data.language
     * @returns FrontJackpotWinnersV2ResponseDto
     * @throws ApiError
     */
    public static getFrontJackpotByJackpotIdWinners(data: GetFrontJackpotByJackpotIdWinnersData): CancelablePromise<GetFrontJackpotByJackpotIdWinnersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/jackpot/{jackpotId}/winners',
            path: {
                jackpotId: data.jackpotId
            },
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
}

export class FrontLocaleService {
    /**
     * @returns FrontLocaleResponseDto
     * @throws ApiError
     */
    public static getFrontLocale(): CancelablePromise<GetFrontLocaleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/locale'
        });
    }
    
}

export class FrontTicketService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static getFrontTicket(): CancelablePromise<GetFrontTicketResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/ticket'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.ticketId
     * @returns FrontTicketPurchaseResponseDto
     * @throws ApiError
     */
    public static getFrontTicketOffers(data: GetFrontTicketOffersData): CancelablePromise<GetFrontTicketOffersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/ticket/offers',
            query: {
                hostname: data.hostname,
                language: data.language,
                ticketId: data.ticketId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.ticketId
     * @returns FrontTicketStatsResponseDto
     * @throws ApiError
     */
    public static getFrontTicketStats(data: GetFrontTicketStatsData): CancelablePromise<GetFrontTicketStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/ticket/stats',
            query: {
                hostname: data.hostname,
                language: data.language,
                ticketId: data.ticketId
            }
        });
    }
    
}

export class FrontLeaderboardService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @returns FrontJackpotWinnersResponseDto
     * @throws ApiError
     */
    public static getFrontLeaderboardWinners(data: GetFrontLeaderboardWinnersData): CancelablePromise<GetFrontLeaderboardWinnersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/leaderboard/winners',
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.ticketId
     * @returns FrontLeaderboardResponseDto
     * @throws ApiError
     */
    public static getFrontLeaderboard(data: GetFrontLeaderboardData): CancelablePromise<GetFrontLeaderboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/leaderboard',
            query: {
                hostname: data.hostname,
                language: data.language,
                ticketId: data.ticketId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.ticketId
     * @returns FrontLeaderboardResponseDto
     * @throws ApiError
     */
    public static getFrontLeaderboardUserLeaderboard(data: GetFrontLeaderboardUserLeaderboardData): CancelablePromise<GetFrontLeaderboardUserLeaderboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/leaderboard/user-leaderboard',
            query: {
                hostname: data.hostname,
                language: data.language,
                ticketId: data.ticketId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.jackpotId
     * @returns FrontLeaderboardV2ResponseDto
     * @throws ApiError
     */
    public static getV2FrontLeaderboard(data: GetV2FrontLeaderboardData): CancelablePromise<GetV2FrontLeaderboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/front/leaderboard',
            query: {
                hostname: data.hostname,
                language: data.language,
                jackpotId: data.jackpotId
            }
        });
    }
    
}

export class FrontWalletService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FrontWalletConnectResponseDto
     * @throws ApiError
     */
    public static postFrontWalletConnect(data: PostFrontWalletConnectData): CancelablePromise<PostFrontWalletConnectResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/wallet/connect',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FrontWalletVerifyResponseDto
     * @throws ApiError
     */
    public static postFrontWalletVerify(data: PostFrontWalletVerifyData): CancelablePromise<PostFrontWalletVerifyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/wallet/verify',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @returns FrontWalletVerifyResponseDto
     * @throws ApiError
     */
    public static postFrontWalletDisconnect(): CancelablePromise<PostFrontWalletDisconnectResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/wallet/disconnect',
            errors: {
                400: ''
            }
        });
    }
    
}

export class FrontCurrencyService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.source
     * @param data.target
     * @returns FrontCurrencyRateResponseDto
     * @throws ApiError
     */
    public static getFrontCurrencyRate(data: GetFrontCurrencyRateData): CancelablePromise<GetFrontCurrencyRateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/currency/rate',
            query: {
                hostname: data.hostname,
                language: data.language,
                source: data.source,
                target: data.target
            }
        });
    }
    
}

export class FrontUserTicketService {
    /**
     * @returns FrontUserTicketsBalanceResponseDto
     * @throws ApiError
     */
    public static getFrontUserTicketBalance(): CancelablePromise<GetFrontUserTicketBalanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/user/ticket/balance'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ticketId
     * @returns FrontUserTicketBalanceResponseDto
     * @throws ApiError
     */
    public static getFrontUserTicketTicketBalanceByTicketId(data: GetFrontUserTicketTicketBalanceByTicketIdData): CancelablePromise<GetFrontUserTicketTicketBalanceByTicketIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/user/ticket/ticket-balance/{ticketId}',
            path: {
                ticketId: data.ticketId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @returns FrontUserTicketsBalanceV2ResponseDto
     * @throws ApiError
     */
    public static getV2FrontUserTicketBalance(data: GetV2FrontUserTicketBalanceData): CancelablePromise<GetV2FrontUserTicketBalanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/front/user/ticket/balance',
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.ticketId
     * @returns FrontUserTicketBalanceV2ResponseDto
     * @throws ApiError
     */
    public static getV2FrontUserTicketTicketBalanceByTicketId(data: GetV2FrontUserTicketTicketBalanceByTicketIdData): CancelablePromise<GetV2FrontUserTicketTicketBalanceByTicketIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/front/user/ticket/ticket-balance/{ticketId}',
            query: {
                hostname: data.hostname,
                language: data.language,
                ticketId: data.ticketId
            }
        });
    }
    
}

export class FrontUserBalanceService {
    /**
     * @returns FrontUserBalanceResponseDto
     * @throws ApiError
     */
    public static getFrontUserBalanceBalance(): CancelablePromise<GetFrontUserBalanceBalanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/user/balance/balance'
        });
    }
    
}

export class FrontUserReferralService {
    /**
     * @param data The data for the request.
     * @param data.timeframe
     * @returns FrontUserReferralStatsResponseDto
     * @throws ApiError
     */
    public static getFrontUserReferralStatsByTimeframe(data: GetFrontUserReferralStatsByTimeframeData): CancelablePromise<GetFrontUserReferralStatsByTimeframeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/user/referral/stats/{timeframe}',
            path: {
                timeframe: data.timeframe
            }
        });
    }
    
}

export class FrontCmsService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.access
     * @param data.slug
     * @returns FrontCmsPageResponseDto
     * @throws ApiError
     */
    public static getFrontCms(data: GetFrontCmsData): CancelablePromise<GetFrontCmsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/cms',
            query: {
                hostname: data.hostname,
                language: data.language,
                access: data.access,
                slug: data.slug
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @returns unknown
     * @throws ApiError
     */
    public static getFrontCmsSitemap(data: GetFrontCmsSitemapData): CancelablePromise<GetFrontCmsSitemapResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/cms/sitemap',
            query: {
                hostname: data.hostname,
                language: data.language
            }
        });
    }
    
}

export class FrontFaqService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.tags
     * @returns FrontFaqResponseDto
     * @throws ApiError
     */
    public static getFrontFaq(data: GetFrontFaqData): CancelablePromise<GetFrontFaqResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/faq',
            query: {
                hostname: data.hostname,
                language: data.language,
                tags: data.tags
            }
        });
    }
    
}

export class FrontI18NService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.ns
     * @returns unknown
     * @throws ApiError
     */
    public static getFrontI18N(data: GetFrontI18NData): CancelablePromise<GetFrontI18NResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/i18n',
            query: {
                hostname: data.hostname,
                language: data.language,
                ns: data.ns
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.ns
     * @returns unknown
     * @throws ApiError
     */
    public static getV2FrontI18N(data: GetV2FrontI18NData): CancelablePromise<GetV2FrontI18NResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/front/i18n',
            query: {
                hostname: data.hostname,
                language: data.language,
                ns: data.ns
            }
        });
    }
    
}

export class FrontPurchaseService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FrontSinglePurchaseResponseDto
     * @throws ApiError
     */
    public static postFrontPurchaseSinglePurchase(data: PostFrontPurchaseSinglePurchaseData): CancelablePromise<PostFrontPurchaseSinglePurchaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/front/purchase/single-purchase',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class FrontStatsService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @returns FrontJackpotPlatformStatsResponseDto
     * @throws ApiError
     */
    public static getFrontStatsPlatformStats(data: GetFrontStatsPlatformStatsData): CancelablePromise<GetFrontStatsPlatformStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/stats/platform-stats',
            query: {
                hostname: data.hostname
            }
        });
    }
    
}

export class FrontWinnersService {
    /**
     * @param data The data for the request.
     * @param data.hostname
     * @param data.language
     * @param data.jackpotId
     * @returns FrontWinnersV1ResponseDto
     * @throws ApiError
     */
    public static getFrontWinners(data: GetFrontWinnersData): CancelablePromise<GetFrontWinnersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/front/winners',
            query: {
                hostname: data.hostname,
                language: data.language,
                jackpotId: data.jackpotId
            }
        });
    }
    
}

export class AdminBrandService {
    /**
     * @returns AdminBrandResponseDto
     * @throws ApiError
     */
    public static getAdminBrand(): CancelablePromise<GetAdminBrandResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminBrandResponseDto
     * @throws ApiError
     */
    public static postAdminBrand(data: PostAdminBrandData): CancelablePromise<PostAdminBrandResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/brand',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @returns AdminBrandResponseDto
     * @throws ApiError
     */
    public static getAdminBrandByBrandId(data: GetAdminBrandByBrandIdData): CancelablePromise<GetAdminBrandByBrandIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand/{brandId}',
            path: {
                brandId: data.brandId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandId(data: DeleteAdminBrandByBrandIdData): CancelablePromise<DeleteAdminBrandByBrandIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}',
            path: {
                brandId: data.brandId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.requestBody
     * @returns AdminBrandResponseDto
     * @throws ApiError
     */
    public static putAdminBrandByBrandId(data: PutAdminBrandByBrandIdData): CancelablePromise<PutAdminBrandByBrandIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}',
            path: {
                brandId: data.brandId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.requestBody
     * @returns AdminBrandEnvironmentResponseDto
     * @throws ApiError
     */
    public static postAdminBrandByBrandIdEnvironment(data: PostAdminBrandByBrandIdEnvironmentData): CancelablePromise<PostAdminBrandByBrandIdEnvironmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/brand/{brandId}/environment',
            path: {
                brandId: data.brandId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.requestBody
     * @returns AdminBrandEnvironmentResponseDto
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdEnvironment(data: PutAdminBrandByBrandIdEnvironmentData): CancelablePromise<PutAdminBrandByBrandIdEnvironmentResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/environment',
            path: {
                brandId: data.brandId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdEnvironment(data: DeleteAdminBrandByBrandIdEnvironmentData): CancelablePromise<DeleteAdminBrandByBrandIdEnvironmentResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/environment',
            path: {
                brandId: data.brandId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static getAdminBrandByBrandIdConfiguration(data: GetAdminBrandByBrandIdConfigurationData): CancelablePromise<GetAdminBrandByBrandIdConfigurationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand/{brandId}/configuration',
            path: {
                brandId: data.brandId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.requestBody
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static postAdminBrandByBrandIdConfiguration(data: PostAdminBrandByBrandIdConfigurationData): CancelablePromise<PostAdminBrandByBrandIdConfigurationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/brand/{brandId}/configuration',
            path: {
                brandId: data.brandId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.configId
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static getAdminBrandConfigurationByConfigId(data: GetAdminBrandConfigurationByConfigIdData): CancelablePromise<GetAdminBrandConfigurationByConfigIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand/configuration/{configId}',
            path: {
                configId: data.configId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @param data.requestBody
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdConfigurationByConfigId(data: PutAdminBrandByBrandIdConfigurationByConfigIdData): CancelablePromise<PutAdminBrandByBrandIdConfigurationByConfigIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/configuration/{configId}',
            path: {
                brandId: data.brandId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdConfigurationByConfigId(data: DeleteAdminBrandByBrandIdConfigurationByConfigIdData): CancelablePromise<DeleteAdminBrandByBrandIdConfigurationByConfigIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/configuration/{configId}',
            path: {
                brandId: data.brandId,
                configId: data.configId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @param data.requestBody
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobile(data: PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobileData): CancelablePromise<PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobileResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/configuration/{configId}/header-logo-mobile',
            path: {
                brandId: data.brandId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobile(data: DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobileData): CancelablePromise<DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoMobileResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/configuration/{configId}/header-logo-mobile',
            path: {
                brandId: data.brandId,
                configId: data.configId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @param data.requestBody
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktop(data: PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktopData): CancelablePromise<PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktopResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/configuration/{configId}/header-logo-desktop',
            path: {
                brandId: data.brandId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktop(data: DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktopData): CancelablePromise<DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLogoDesktopResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/configuration/{configId}/header-logo-desktop',
            path: {
                brandId: data.brandId,
                configId: data.configId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @param data.requestBody
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdConfigurationByConfigIdFooterLogo(data: PutAdminBrandByBrandIdConfigurationByConfigIdFooterLogoData): CancelablePromise<PutAdminBrandByBrandIdConfigurationByConfigIdFooterLogoResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/configuration/{configId}/footer-logo',
            path: {
                brandId: data.brandId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdConfigurationByConfigIdFooterLogo(data: DeleteAdminBrandByBrandIdConfigurationByConfigIdFooterLogoData): CancelablePromise<DeleteAdminBrandByBrandIdConfigurationByConfigIdFooterLogoResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/configuration/{configId}/footer-logo',
            path: {
                brandId: data.brandId,
                configId: data.configId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @param data.requestBody
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticated(data: PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticatedData): CancelablePromise<PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticatedResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/configuration/{configId}/header-links-authenticated',
            path: {
                brandId: data.brandId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticated(data: DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticatedData): CancelablePromise<DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksAuthenticatedResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/configuration/{configId}/header-links-authenticated',
            path: {
                brandId: data.brandId,
                configId: data.configId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @param data.requestBody
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuest(data: PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuestData): CancelablePromise<PutAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuestResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/configuration/{configId}/header-links-guest',
            path: {
                brandId: data.brandId,
                configId: data.configId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuest(data: DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuestData): CancelablePromise<DeleteAdminBrandByBrandIdConfigurationByConfigIdHeaderLinksGuestResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/configuration/{configId}/header-links-guest',
            path: {
                brandId: data.brandId,
                configId: data.configId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @param data.linkListType
     * @param data.requestBody
     * @returns BrandConfiguration
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListType(data: PutAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListTypeData): CancelablePromise<PutAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListTypeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/configuration/{configId}/footer-links/{linkListType}',
            path: {
                brandId: data.brandId,
                configId: data.configId,
                linkListType: data.linkListType
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.configId
     * @param data.linkListType
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListType(data: DeleteAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListTypeData): CancelablePromise<DeleteAdminBrandByBrandIdConfigurationByConfigIdFooterLinksByLinkListTypeResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/configuration/{configId}/footer-links/{linkListType}',
            path: {
                brandId: data.brandId,
                configId: data.configId,
                linkListType: data.linkListType
            }
        });
    }
    
}

export class AdminBrandTicketofferService {
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @returns AdminBrandTicketOfferListResponseDto
     * @throws ApiError
     */
    public static getAdminBrandByBrandIdTicketoffer(data: GetAdminBrandByBrandIdTicketofferData): CancelablePromise<GetAdminBrandByBrandIdTicketofferResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand/{brandId}/ticketoffer',
            path: {
                brandId: data.brandId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.requestBody
     * @returns AdminBrandTicketOfferResponseDto
     * @throws ApiError
     */
    public static postAdminBrandByBrandIdTicketoffer(data: PostAdminBrandByBrandIdTicketofferData): CancelablePromise<PostAdminBrandByBrandIdTicketofferResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/brand/{brandId}/ticketoffer',
            path: {
                brandId: data.brandId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.ticketOfferId
     * @returns AdminBrandTicketOfferResponseDto
     * @throws ApiError
     */
    public static getAdminBrandByBrandIdTicketofferByTicketOfferId(data: GetAdminBrandByBrandIdTicketofferByTicketOfferIdData): CancelablePromise<GetAdminBrandByBrandIdTicketofferByTicketOfferIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand/{brandId}/ticketoffer/{ticketOfferId}',
            path: {
                brandId: data.brandId,
                ticketOfferId: data.ticketOfferId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.ticketOfferId
     * @param data.requestBody
     * @returns AdminBrandTicketOfferResponseDto
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdTicketofferByTicketOfferId(data: PutAdminBrandByBrandIdTicketofferByTicketOfferIdData): CancelablePromise<PutAdminBrandByBrandIdTicketofferByTicketOfferIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/ticketoffer/{ticketOfferId}',
            path: {
                brandId: data.brandId,
                ticketOfferId: data.ticketOfferId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.ticketOfferId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdTicketofferByTicketOfferId(data: DeleteAdminBrandByBrandIdTicketofferByTicketOfferIdData): CancelablePromise<DeleteAdminBrandByBrandIdTicketofferByTicketOfferIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/ticketoffer/{ticketOfferId}',
            path: {
                brandId: data.brandId,
                ticketOfferId: data.ticketOfferId
            }
        });
    }
    
}

export class AdminBrandTicketofferI18NService {
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.ticketOfferId
     * @returns AdminBrandTicketOfferI18nListResponseDto
     * @throws ApiError
     */
    public static getAdminBrandByBrandIdTicketofferByTicketOfferIdI18N(data: GetAdminBrandByBrandIdTicketofferByTicketOfferIdI18NData): CancelablePromise<GetAdminBrandByBrandIdTicketofferByTicketOfferIdI18NResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand/{brandId}/ticketoffer/{ticketOfferId}/i18n',
            path: {
                brandId: data.brandId,
                ticketOfferId: data.ticketOfferId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.ticketOfferId
     * @param data.requestBody
     * @returns AdminBrandTicketOfferI18nResponseDto
     * @throws ApiError
     */
    public static postAdminBrandByBrandIdTicketofferByTicketOfferIdI18N(data: PostAdminBrandByBrandIdTicketofferByTicketOfferIdI18NData): CancelablePromise<PostAdminBrandByBrandIdTicketofferByTicketOfferIdI18NResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/brand/{brandId}/ticketoffer/{ticketOfferId}/i18n',
            path: {
                brandId: data.brandId,
                ticketOfferId: data.ticketOfferId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.ticketOfferId
     * @param data.i18nId
     * @returns AdminBrandTicketOfferI18nResponseDto
     * @throws ApiError
     */
    public static getAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nId(data: GetAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdData): CancelablePromise<GetAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand/{brandId}/ticketoffer/{ticketOfferId}/i18n/{i18nId}',
            path: {
                brandId: data.brandId,
                ticketOfferId: data.ticketOfferId,
                i18nId: data.i18nId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.ticketOfferId
     * @param data.i18nId
     * @param data.requestBody
     * @returns AdminBrandTicketOfferI18nResponseDto
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nId(data: PutAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdData): CancelablePromise<PutAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/ticketoffer/{ticketOfferId}/i18n/{i18nId}',
            path: {
                brandId: data.brandId,
                ticketOfferId: data.ticketOfferId,
                i18nId: data.i18nId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.ticketOfferId
     * @param data.i18nId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nId(data: DeleteAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdData): CancelablePromise<DeleteAdminBrandByBrandIdTicketofferByTicketOfferIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/ticketoffer/{ticketOfferId}/i18n/{i18nId}',
            path: {
                brandId: data.brandId,
                ticketOfferId: data.ticketOfferId,
                i18nId: data.i18nId
            }
        });
    }
    
}

export class AdminBrandTicketService {
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.brandTicketId
     * @returns AdminBrandTicketResponseDto
     * @throws ApiError
     */
    public static getAdminBrandByBrandIdTicketByBrandTicketId(data: GetAdminBrandByBrandIdTicketByBrandTicketIdData): CancelablePromise<GetAdminBrandByBrandIdTicketByBrandTicketIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/brand/{brandId}/ticket/{brandTicketId}',
            path: {
                brandId: data.brandId,
                brandTicketId: data.brandTicketId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.brandTicketId
     * @param data.requestBody
     * @returns AdminBrandTicketResponseDto
     * @throws ApiError
     */
    public static putAdminBrandByBrandIdTicketByBrandTicketId(data: PutAdminBrandByBrandIdTicketByBrandTicketIdData): CancelablePromise<PutAdminBrandByBrandIdTicketByBrandTicketIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/brand/{brandId}/ticket/{brandTicketId}',
            path: {
                brandId: data.brandId,
                brandTicketId: data.brandTicketId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.brandTicketId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminBrandByBrandIdTicketByBrandTicketId(data: DeleteAdminBrandByBrandIdTicketByBrandTicketIdData): CancelablePromise<DeleteAdminBrandByBrandIdTicketByBrandTicketIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/brand/{brandId}/ticket/{brandTicketId}',
            path: {
                brandId: data.brandId,
                brandTicketId: data.brandTicketId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.brandId
     * @param data.requestBody
     * @returns AdminBrandTicketResponseDto
     * @throws ApiError
     */
    public static postAdminBrandByBrandIdTicket(data: PostAdminBrandByBrandIdTicketData): CancelablePromise<PostAdminBrandByBrandIdTicketResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/brand/{brandId}/ticket',
            path: {
                brandId: data.brandId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
}

export class AdminFaqService {
    /**
     * @param data The data for the request.
     * @param data.filters Filters as JSON string. Example: [{"field":"name","value":"test","condition":"eq"}]
     * @param data.sort Sort as JSON string. Example: [{"field":"label","direction":"asc"}]
     * @param data.limit Number of items per page
     * @param data.page Page number for pagination
     * @returns unknown
     * @throws ApiError
     */
    public static getAdminFaq(data: GetAdminFaqData = {}): CancelablePromise<GetAdminFaqResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/faq',
            query: {
                filters: data.filters,
                sort: data.sort,
                limit: data.limit,
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminFaqResponseDto
     * @throws ApiError
     */
    public static postAdminFaq(data: PostAdminFaqData): CancelablePromise<PostAdminFaqResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/faq',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @returns Faq
     * @throws ApiError
     */
    public static getAdminFaqByFaqId(data: GetAdminFaqByFaqIdData): CancelablePromise<GetAdminFaqByFaqIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/faq/{faqId}',
            path: {
                faqId: data.faqId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @param data.requestBody
     * @returns AdminFaqResponseDto
     * @throws ApiError
     */
    public static putAdminFaqByFaqId(data: PutAdminFaqByFaqIdData): CancelablePromise<PutAdminFaqByFaqIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/faq/{faqId}',
            path: {
                faqId: data.faqId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminFaqByFaqId(data: DeleteAdminFaqByFaqIdData): CancelablePromise<DeleteAdminFaqByFaqIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/faq/{faqId}',
            path: {
                faqId: data.faqId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @param data.requestBody
     * @returns AdminFaqBrandResponseDto
     * @throws ApiError
     */
    public static postAdminFaqByFaqIdBrand(data: PostAdminFaqByFaqIdBrandData): CancelablePromise<PostAdminFaqByFaqIdBrandResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/faq/{faqId}/brand',
            path: {
                faqId: data.faqId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @param data.brandFaqId
     * @param data.requestBody
     * @returns AdminFaqBrandResponseDto
     * @throws ApiError
     */
    public static putAdminFaqByFaqIdBrandByBrandFaqId(data: PutAdminFaqByFaqIdBrandByBrandFaqIdData): CancelablePromise<PutAdminFaqByFaqIdBrandByBrandFaqIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/faq/{faqId}/brand/{brandFaqId}',
            path: {
                faqId: data.faqId,
                brandFaqId: data.brandFaqId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @param data.brandFaqId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminFaqByFaqIdBrandByBrandFaqId(data: DeleteAdminFaqByFaqIdBrandByBrandFaqIdData): CancelablePromise<DeleteAdminFaqByFaqIdBrandByBrandFaqIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/faq/{faqId}/brand/{brandFaqId}',
            path: {
                faqId: data.faqId,
                brandFaqId: data.brandFaqId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @param data.requestBody
     * @returns AdminFaqI18nResponseDto
     * @throws ApiError
     */
    public static postAdminFaqByFaqIdI18N(data: PostAdminFaqByFaqIdI18NData): CancelablePromise<PostAdminFaqByFaqIdI18NResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/faq/{faqId}/i18n',
            path: {
                faqId: data.faqId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @param data.i18nId
     * @param data.requestBody
     * @returns AdminFaqI18nResponseDto
     * @throws ApiError
     */
    public static putAdminFaqByFaqIdI18nByI18nId(data: PutAdminFaqByFaqIdI18nByI18nIdData): CancelablePromise<PutAdminFaqByFaqIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/faq/{faqId}/i18n/{i18nId}',
            path: {
                faqId: data.faqId,
                i18nId: data.i18nId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @param data.i18nId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminFaqByFaqIdI18nByI18nId(data: DeleteAdminFaqByFaqIdI18nByI18nIdData): CancelablePromise<DeleteAdminFaqByFaqIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/faq/{faqId}/i18n/{i18nId}',
            path: {
                faqId: data.faqId,
                i18nId: data.i18nId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.qaId
     * @returns FaqQa
     * @throws ApiError
     */
    public static getAdminFaqQaByQaId(data: GetAdminFaqQaByQaIdData): CancelablePromise<GetAdminFaqQaByQaIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/faq/qa/{qaId}',
            path: {
                qaId: data.qaId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.qaId
     * @param data.requestBody
     * @returns AdminFaqQaResponseDto
     * @throws ApiError
     */
    public static putAdminFaqQaByQaId(data: PutAdminFaqQaByQaIdData): CancelablePromise<PutAdminFaqQaByQaIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/faq/qa/{qaId}',
            path: {
                qaId: data.qaId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.qaId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminFaqQaByQaId(data: DeleteAdminFaqQaByQaIdData): CancelablePromise<DeleteAdminFaqQaByQaIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/faq/qa/{qaId}',
            path: {
                qaId: data.qaId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminFaqQaResponseDto
     * @throws ApiError
     */
    public static postAdminFaqQa(data: PostAdminFaqQaData): CancelablePromise<PostAdminFaqQaResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/faq/qa',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @returns BrandFaq
     * @throws ApiError
     */
    public static getAdminFaqByFaqIdBrands(data: GetAdminFaqByFaqIdBrandsData): CancelablePromise<GetAdminFaqByFaqIdBrandsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/faq/{faqId}/brands',
            path: {
                faqId: data.faqId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.faqId
     * @returns FaqQa
     * @throws ApiError
     */
    public static getAdminFaqByFaqIdQa(data: GetAdminFaqByFaqIdQaData): CancelablePromise<GetAdminFaqByFaqIdQaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/faq/{faqId}/qa',
            path: {
                faqId: data.faqId
            }
        });
    }
    
}

export class AdminLocaleService {
    /**
     * @returns AdminLocaleResponseDto
     * @throws ApiError
     */
    public static getAdminLocale(): CancelablePromise<GetAdminLocaleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/locale'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminLocaleResponseDto
     * @throws ApiError
     */
    public static postAdminLocale(data: PostAdminLocaleData): CancelablePromise<PostAdminLocaleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/locale',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.localeId
     * @returns AdminLocaleResponseDto
     * @throws ApiError
     */
    public static getAdminLocaleByLocaleId(data: GetAdminLocaleByLocaleIdData): CancelablePromise<GetAdminLocaleByLocaleIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/locale/{localeId}',
            path: {
                localeId: data.localeId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.localeId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminLocaleByLocaleId(data: DeleteAdminLocaleByLocaleIdData): CancelablePromise<DeleteAdminLocaleByLocaleIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/locale/{localeId}',
            path: {
                localeId: data.localeId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.localeId
     * @param data.requestBody
     * @returns AdminLocaleResponseDto
     * @throws ApiError
     */
    public static putAdminLocaleByLocaleId(data: PutAdminLocaleByLocaleIdData): CancelablePromise<PutAdminLocaleByLocaleIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/locale/{localeId}',
            path: {
                localeId: data.localeId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class AdminJackpotService {
    /**
     * @returns string
     * @throws ApiError
     */
    public static getAdminJackpotTriggerJackpots(): CancelablePromise<GetAdminJackpotTriggerJackpotsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/jackpot/trigger-jackpots'
        });
    }
    
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static getAdminJackpotTriggerDraws(): CancelablePromise<GetAdminJackpotTriggerDrawsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/jackpot/trigger-draws'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters Filters as JSON string. Example: [{"field":"name","value":"test","condition":"eq"}]
     * @param data.sort Sort as JSON string. Example: [{"field":"label","direction":"asc"}]
     * @param data.limit Number of items per page
     * @param data.page Page number for pagination
     * @returns unknown
     * @throws ApiError
     */
    public static getAdminJackpot(data: GetAdminJackpotData = {}): CancelablePromise<GetAdminJackpotResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/jackpot',
            query: {
                filters: data.filters,
                sort: data.sort,
                limit: data.limit,
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static postAdminJackpot(data: PostAdminJackpotData): CancelablePromise<PostAdminJackpotResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/jackpot',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static getAdminJackpotByJackpotId(data: GetAdminJackpotByJackpotIdData): CancelablePromise<GetAdminJackpotByJackpotIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/jackpot/{jackpotId}',
            path: {
                jackpotId: data.jackpotId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static putAdminJackpotByJackpotId(data: PutAdminJackpotByJackpotIdData): CancelablePromise<PutAdminJackpotByJackpotIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/jackpot/{jackpotId}',
            path: {
                jackpotId: data.jackpotId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminJackpotByJackpotId(data: DeleteAdminJackpotByJackpotIdData): CancelablePromise<DeleteAdminJackpotByJackpotIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/jackpot/{jackpotId}',
            path: {
                jackpotId: data.jackpotId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static postAdminJackpotByJackpotIdPrize(data: PostAdminJackpotByJackpotIdPrizeData): CancelablePromise<PostAdminJackpotByJackpotIdPrizeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/jackpot/{jackpotId}/prize',
            path: {
                jackpotId: data.jackpotId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.prizeId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static putAdminJackpotByJackpotIdPrizeByPrizeId(data: PutAdminJackpotByJackpotIdPrizeByPrizeIdData): CancelablePromise<PutAdminJackpotByJackpotIdPrizeByPrizeIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/jackpot/{jackpotId}/prize/{prizeId}',
            path: {
                jackpotId: data.jackpotId,
                prizeId: data.prizeId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.prizeId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminJackpotByJackpotIdPrizeByPrizeId(data: DeleteAdminJackpotByJackpotIdPrizeByPrizeIdData): CancelablePromise<DeleteAdminJackpotByJackpotIdPrizeByPrizeIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/jackpot/{jackpotId}/prize/{prizeId}',
            path: {
                jackpotId: data.jackpotId,
                prizeId: data.prizeId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static postAdminJackpotByJackpotIdAcceptanceCondition(data: PostAdminJackpotByJackpotIdAcceptanceConditionData): CancelablePromise<PostAdminJackpotByJackpotIdAcceptanceConditionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/jackpot/{jackpotId}/acceptance-condition',
            path: {
                jackpotId: data.jackpotId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.conditionId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static putAdminJackpotByJackpotIdAcceptanceConditionByConditionId(data: PutAdminJackpotByJackpotIdAcceptanceConditionByConditionIdData): CancelablePromise<PutAdminJackpotByJackpotIdAcceptanceConditionByConditionIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/jackpot/{jackpotId}/acceptance-condition/{conditionId}',
            path: {
                jackpotId: data.jackpotId,
                conditionId: data.conditionId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.conditionId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminJackpotByJackpotIdAcceptanceConditionByConditionId(data: DeleteAdminJackpotByJackpotIdAcceptanceConditionByConditionIdData): CancelablePromise<DeleteAdminJackpotByJackpotIdAcceptanceConditionByConditionIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/jackpot/{jackpotId}/acceptance-condition/{conditionId}',
            path: {
                jackpotId: data.jackpotId,
                conditionId: data.conditionId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static postAdminJackpotByJackpotIdI18N(data: PostAdminJackpotByJackpotIdI18NData): CancelablePromise<PostAdminJackpotByJackpotIdI18NResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/jackpot/{jackpotId}/i18n',
            path: {
                jackpotId: data.jackpotId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.i18nId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static putAdminJackpotByJackpotIdI18nByI18nId(data: PutAdminJackpotByJackpotIdI18nByI18nIdData): CancelablePromise<PutAdminJackpotByJackpotIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/jackpot/{jackpotId}/i18n/{i18nId}',
            path: {
                jackpotId: data.jackpotId,
                i18nId: data.i18nId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.i18nId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminJackpotByJackpotIdI18nByI18nId(data: DeleteAdminJackpotByJackpotIdI18nByI18nIdData): CancelablePromise<DeleteAdminJackpotByJackpotIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/jackpot/{jackpotId}/i18n/{i18nId}',
            path: {
                jackpotId: data.jackpotId,
                i18nId: data.i18nId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static postAdminJackpotByJackpotIdPool(data: PostAdminJackpotByJackpotIdPoolData): CancelablePromise<PostAdminJackpotByJackpotIdPoolResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/jackpot/{jackpotId}/pool',
            path: {
                jackpotId: data.jackpotId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.poolId
     * @param data.requestBody
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static putAdminJackpotByJackpotIdPoolByPoolId(data: PutAdminJackpotByJackpotIdPoolByPoolIdData): CancelablePromise<PutAdminJackpotByJackpotIdPoolByPoolIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/jackpot/{jackpotId}/pool/{poolId}',
            path: {
                jackpotId: data.jackpotId,
                poolId: data.poolId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.poolId
     * @returns AdminJackpotResponseDto
     * @throws ApiError
     */
    public static deleteAdminJackpotByJackpotIdPoolByPoolId(data: DeleteAdminJackpotByJackpotIdPoolByPoolIdData): CancelablePromise<DeleteAdminJackpotByJackpotIdPoolByPoolIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/jackpot/{jackpotId}/pool/{poolId}',
            path: {
                jackpotId: data.jackpotId,
                poolId: data.poolId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.requestBody
     * @returns AdminJackpotBrandResponseDto
     * @throws ApiError
     */
    public static postAdminJackpotByJackpotIdBrand(data: PostAdminJackpotByJackpotIdBrandData): CancelablePromise<PostAdminJackpotByJackpotIdBrandResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/jackpot/{jackpotId}/brand',
            path: {
                jackpotId: data.jackpotId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.brandJackpotId
     * @param data.requestBody
     * @returns AdminJackpotBrandResponseDto
     * @throws ApiError
     */
    public static putAdminJackpotByJackpotIdBrandByBrandJackpotId(data: PutAdminJackpotByJackpotIdBrandByBrandJackpotIdData): CancelablePromise<PutAdminJackpotByJackpotIdBrandByBrandJackpotIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/jackpot/{jackpotId}/brand/{brandJackpotId}',
            path: {
                jackpotId: data.jackpotId,
                brandJackpotId: data.brandJackpotId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.jackpotId
     * @param data.brandJackpotId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminJackpotByJackpotIdBrandByBrandJackpotId(data: DeleteAdminJackpotByJackpotIdBrandByBrandJackpotIdData): CancelablePromise<DeleteAdminJackpotByJackpotIdBrandByBrandJackpotIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/jackpot/{jackpotId}/brand/{brandJackpotId}',
            path: {
                jackpotId: data.jackpotId,
                brandJackpotId: data.brandJackpotId
            }
        });
    }
    
}

export class AdminTicketService {
    /**
     * @returns AdminTicketResponseDto
     * @throws ApiError
     */
    public static getAdminTicket(): CancelablePromise<GetAdminTicketResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/ticket'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminTicketResponseDto
     * @throws ApiError
     */
    public static postAdminTicket(data: PostAdminTicketData): CancelablePromise<PostAdminTicketResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/ticket',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ticketId
     * @returns AdminTicketResponseDto
     * @throws ApiError
     */
    public static getAdminTicketByTicketId(data: GetAdminTicketByTicketIdData): CancelablePromise<GetAdminTicketByTicketIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/ticket/{ticketId}',
            path: {
                ticketId: data.ticketId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ticketId
     * @param data.requestBody
     * @returns AdminTicketResponseDto
     * @throws ApiError
     */
    public static putAdminTicketByTicketId(data: PutAdminTicketByTicketIdData): CancelablePromise<PutAdminTicketByTicketIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/ticket/{ticketId}',
            path: {
                ticketId: data.ticketId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ticketId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminTicketByTicketId(data: DeleteAdminTicketByTicketIdData): CancelablePromise<DeleteAdminTicketByTicketIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/ticket/{ticketId}',
            path: {
                ticketId: data.ticketId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ticketId
     * @param data.requestBody
     * @returns AdminTicketResponseDto
     * @throws ApiError
     */
    public static postAdminTicketByTicketIdI18N(data: PostAdminTicketByTicketIdI18NData): CancelablePromise<PostAdminTicketByTicketIdI18NResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/ticket/{ticketId}/i18n',
            path: {
                ticketId: data.ticketId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ticketId
     * @param data.i18nId
     * @param data.requestBody
     * @returns AdminTicketResponseDto
     * @throws ApiError
     */
    public static putAdminTicketByTicketIdI18nByI18nId(data: PutAdminTicketByTicketIdI18nByI18nIdData): CancelablePromise<PutAdminTicketByTicketIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/ticket/{ticketId}/i18n/{i18nId}',
            path: {
                ticketId: data.ticketId,
                i18nId: data.i18nId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.ticketId
     * @param data.i18nId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminTicketByTicketIdI18nByI18nId(data: DeleteAdminTicketByTicketIdI18nByI18nIdData): CancelablePromise<DeleteAdminTicketByTicketIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/ticket/{ticketId}/i18n/{i18nId}',
            path: {
                ticketId: data.ticketId,
                i18nId: data.i18nId
            }
        });
    }
    
}

export class AdminMissionService {
    /**
     * @param data The data for the request.
     * @param data.filters Filters as JSON string. Example: [{"field":"name","value":"test","condition":"eq"}]
     * @param data.sort Sort as JSON string. Example: [{"field":"label","direction":"asc"}]
     * @param data.limit Number of items per page
     * @param data.page Page number for pagination
     * @returns unknown
     * @throws ApiError
     */
    public static getAdminMission(data: GetAdminMissionData = {}): CancelablePromise<GetAdminMissionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/mission',
            query: {
                filters: data.filters,
                sort: data.sort,
                limit: data.limit,
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminMissionResponseDto
     * @throws ApiError
     */
    public static postAdminMission(data: PostAdminMissionData): CancelablePromise<PostAdminMissionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mission',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @returns AdminMissionResponseDto
     * @throws ApiError
     */
    public static getAdminMissionByMissionId(data: GetAdminMissionByMissionIdData): CancelablePromise<GetAdminMissionByMissionIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/mission/{missionId}',
            path: {
                missionId: data.missionId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.requestBody
     * @returns AdminMissionResponseDto
     * @throws ApiError
     */
    public static putAdminMissionByMissionId(data: PutAdminMissionByMissionIdData): CancelablePromise<PutAdminMissionByMissionIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/mission/{missionId}',
            path: {
                missionId: data.missionId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminMissionByMissionId(data: DeleteAdminMissionByMissionIdData): CancelablePromise<DeleteAdminMissionByMissionIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/mission/{missionId}',
            path: {
                missionId: data.missionId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.requestBody
     * @returns AdminMissionResponseDto
     * @throws ApiError
     */
    public static postAdminMissionByMissionIdI18N(data: PostAdminMissionByMissionIdI18NData): CancelablePromise<PostAdminMissionByMissionIdI18NResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mission/{missionId}/i18n',
            path: {
                missionId: data.missionId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.i18nId
     * @param data.requestBody
     * @returns AdminMissionResponseDto
     * @throws ApiError
     */
    public static putAdminMissionByMissionIdI18nByI18nId(data: PutAdminMissionByMissionIdI18nByI18nIdData): CancelablePromise<PutAdminMissionByMissionIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/mission/{missionId}/i18n/{i18nId}',
            path: {
                missionId: data.missionId,
                i18nId: data.i18nId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.i18nId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminMissionByMissionIdI18nByI18nId(data: DeleteAdminMissionByMissionIdI18nByI18nIdData): CancelablePromise<DeleteAdminMissionByMissionIdI18nByI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/mission/{missionId}/i18n/{i18nId}',
            path: {
                missionId: data.missionId,
                i18nId: data.i18nId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.requestBody
     * @returns AdminMissionScheduleResponseDto
     * @throws ApiError
     */
    public static postAdminMissionByMissionIdSchedule(data: PostAdminMissionByMissionIdScheduleData): CancelablePromise<PostAdminMissionByMissionIdScheduleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mission/{missionId}/schedule',
            path: {
                missionId: data.missionId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.scheduleId
     * @param data.requestBody
     * @returns AdminMissionScheduleResponseDto
     * @throws ApiError
     */
    public static putAdminMissionByMissionIdScheduleByScheduleId(data: PutAdminMissionByMissionIdScheduleByScheduleIdData): CancelablePromise<PutAdminMissionByMissionIdScheduleByScheduleIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/mission/{missionId}/schedule/{scheduleId}',
            path: {
                missionId: data.missionId,
                scheduleId: data.scheduleId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.scheduleId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminMissionByMissionIdScheduleByScheduleId(data: DeleteAdminMissionByMissionIdScheduleByScheduleIdData): CancelablePromise<DeleteAdminMissionByMissionIdScheduleByScheduleIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/mission/{missionId}/schedule/{scheduleId}',
            path: {
                missionId: data.missionId,
                scheduleId: data.scheduleId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.requestBody
     * @returns AdminMissionResponseDto
     * @throws ApiError
     */
    public static postAdminMissionByMissionIdTicketReward(data: PostAdminMissionByMissionIdTicketRewardData): CancelablePromise<PostAdminMissionByMissionIdTicketRewardResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mission/{missionId}/ticket-reward',
            path: {
                missionId: data.missionId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.ticketRewardId
     * @param data.requestBody
     * @returns AdminMissionResponseDto
     * @throws ApiError
     */
    public static putAdminMissionByMissionIdTicketRewardByTicketRewardId(data: PutAdminMissionByMissionIdTicketRewardByTicketRewardIdData): CancelablePromise<PutAdminMissionByMissionIdTicketRewardByTicketRewardIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/mission/{missionId}/ticket-reward/{ticketRewardId}',
            path: {
                missionId: data.missionId,
                ticketRewardId: data.ticketRewardId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.ticketRewardId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminMissionByMissionIdTicketRewardByTicketRewardId(data: DeleteAdminMissionByMissionIdTicketRewardByTicketRewardIdData): CancelablePromise<DeleteAdminMissionByMissionIdTicketRewardByTicketRewardIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/mission/{missionId}/ticket-reward/{ticketRewardId}',
            path: {
                missionId: data.missionId,
                ticketRewardId: data.ticketRewardId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.requestBody
     * @returns MissionParameter
     * @throws ApiError
     */
    public static postAdminMissionByMissionIdParameters(data: PostAdminMissionByMissionIdParametersData): CancelablePromise<PostAdminMissionByMissionIdParametersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mission/{missionId}/parameters',
            path: {
                missionId: data.missionId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static putAdminMissionByMissionIdParameters(data: PutAdminMissionByMissionIdParametersData): CancelablePromise<PutAdminMissionByMissionIdParametersResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/mission/{missionId}/parameters',
            path: {
                missionId: data.missionId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.missionId
     * @param data.parameterId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminMissionByMissionIdParameterByParameterId(data: DeleteAdminMissionByMissionIdParameterByParameterIdData): CancelablePromise<DeleteAdminMissionByMissionIdParameterByParameterIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/mission/{missionId}/parameter/{parameterId}',
            path: {
                missionId: data.missionId,
                parameterId: data.parameterId
            }
        });
    }
    
}

export class AdminPoolService {
    /**
     * @returns AdminPoolResponseDto
     * @throws ApiError
     */
    public static getAdminPool(): CancelablePromise<GetAdminPoolResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/pool'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminPoolResponseDto
     * @throws ApiError
     */
    public static postAdminPool(data: PostAdminPoolData): CancelablePromise<PostAdminPoolResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/pool',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.poolId
     * @returns AdminPoolResponseDto
     * @throws ApiError
     */
    public static getAdminPoolByPoolId(data: GetAdminPoolByPoolIdData): CancelablePromise<GetAdminPoolByPoolIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/pool/{poolId}',
            path: {
                poolId: data.poolId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.poolId
     * @param data.requestBody
     * @returns AdminPoolResponseDto
     * @throws ApiError
     */
    public static putAdminPoolByPoolId(data: PutAdminPoolByPoolIdData): CancelablePromise<PutAdminPoolByPoolIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/pool/{poolId}',
            path: {
                poolId: data.poolId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.poolId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminPoolByPoolId(data: DeleteAdminPoolByPoolIdData): CancelablePromise<DeleteAdminPoolByPoolIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/pool/{poolId}',
            path: {
                poolId: data.poolId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.poolId
     * @returns AdminPoolEntryResponseDto
     * @throws ApiError
     */
    public static postAdminPoolByPoolIdEntries(data: PostAdminPoolByPoolIdEntriesData): CancelablePromise<PostAdminPoolByPoolIdEntriesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/pool/{poolId}/entries',
            path: {
                poolId: data.poolId
            },
            errors: {
                400: ''
            }
        });
    }
    
}

export class AdminScheduleService {
    /**
     * @returns AdminScheduleResponseDto
     * @throws ApiError
     */
    public static getAdminSchedule(): CancelablePromise<GetAdminScheduleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/schedule'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminScheduleResponseDto
     * @throws ApiError
     */
    public static postAdminSchedule(data: PostAdminScheduleData): CancelablePromise<PostAdminScheduleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/schedule',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.scheduleId
     * @returns AdminScheduleResponseDto
     * @throws ApiError
     */
    public static getAdminScheduleByScheduleId(data: GetAdminScheduleByScheduleIdData): CancelablePromise<GetAdminScheduleByScheduleIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/schedule/{scheduleId}',
            path: {
                scheduleId: data.scheduleId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.scheduleId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminScheduleByScheduleId(data: DeleteAdminScheduleByScheduleIdData): CancelablePromise<DeleteAdminScheduleByScheduleIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/schedule/{scheduleId}',
            path: {
                scheduleId: data.scheduleId
            }
        });
    }
    
}

export class AdminIdentityService {
    /**
     * @returns AdminIdentityResponseDto
     * @throws ApiError
     */
    public static getAdminIdentity(): CancelablePromise<GetAdminIdentityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/identity'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminIdentityResponseDto
     * @throws ApiError
     */
    public static postAdminIdentity(data: PostAdminIdentityData): CancelablePromise<PostAdminIdentityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/identity',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.identityId
     * @returns AdminIdentityResponseDto
     * @throws ApiError
     */
    public static getAdminIdentityByIdentityId(data: GetAdminIdentityByIdentityIdData): CancelablePromise<GetAdminIdentityByIdentityIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/identity/{identityId}',
            path: {
                identityId: data.identityId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.identityId
     * @param data.requestBody
     * @returns AdminIdentityResponseDto
     * @throws ApiError
     */
    public static putAdminIdentityByIdentityId(data: PutAdminIdentityByIdentityIdData): CancelablePromise<PutAdminIdentityByIdentityIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/identity/{identityId}',
            path: {
                identityId: data.identityId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.identityId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminIdentityByIdentityId(data: DeleteAdminIdentityByIdentityIdData): CancelablePromise<DeleteAdminIdentityByIdentityIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/identity/{identityId}',
            path: {
                identityId: data.identityId
            }
        });
    }
    
}

export class AdminDrawService {
    /**
     * @returns AdminDrawResponseDto
     * @throws ApiError
     */
    public static getAdminDraw(): CancelablePromise<GetAdminDrawResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/draw'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminDrawResponseDto
     * @throws ApiError
     */
    public static postAdminDraw(data: PostAdminDrawData): CancelablePromise<PostAdminDrawResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/draw',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.drawId
     * @returns AdminDrawResponseDto
     * @throws ApiError
     */
    public static getAdminDrawByDrawId(data: GetAdminDrawByDrawIdData): CancelablePromise<GetAdminDrawByDrawIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/draw/{drawId}',
            path: {
                drawId: data.drawId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.drawId
     * @param data.requestBody
     * @returns AdminDrawResponseDto
     * @throws ApiError
     */
    public static putAdminDrawByDrawId(data: PutAdminDrawByDrawIdData): CancelablePromise<PutAdminDrawByDrawIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/draw/{drawId}',
            path: {
                drawId: data.drawId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.drawId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminDrawByDrawId(data: DeleteAdminDrawByDrawIdData): CancelablePromise<DeleteAdminDrawByDrawIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/draw/{drawId}',
            path: {
                drawId: data.drawId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.drawId
     * @param data.requestBody
     * @returns AdminDrawnEntryResponseDto
     * @throws ApiError
     */
    public static postAdminDrawByDrawIdEntry(data: PostAdminDrawByDrawIdEntryData): CancelablePromise<PostAdminDrawByDrawIdEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/draw/{drawId}/entry',
            path: {
                drawId: data.drawId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.drawId
     * @param data.entryId
     * @param data.requestBody
     * @returns AdminDrawnEntryResponseDto
     * @throws ApiError
     */
    public static putAdminDrawByDrawIdEntryByEntryId(data: PutAdminDrawByDrawIdEntryByEntryIdData): CancelablePromise<PutAdminDrawByDrawIdEntryByEntryIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/draw/{drawId}/entry/{entryId}',
            path: {
                drawId: data.drawId,
                entryId: data.entryId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.drawId
     * @param data.entryId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminDrawByDrawIdEntryByEntryId(data: DeleteAdminDrawByDrawIdEntryByEntryIdData): CancelablePromise<DeleteAdminDrawByDrawIdEntryByEntryIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/draw/{drawId}/entry/{entryId}',
            path: {
                drawId: data.drawId,
                entryId: data.entryId
            }
        });
    }
    
}

export class AdminTimezoneService {
    /**
     * @returns string
     * @throws ApiError
     */
    public static getTimezones(): CancelablePromise<GetTimezonesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/timezones'
        });
    }
    
}

export class AdminAuthService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns LoginResponseDto
     * @throws ApiError
     */
    public static postAdminAuthLogin(data: PostAdminAuthLoginData): CancelablePromise<PostAdminAuthLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/auth/login',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static postAdminAuthLogout(): CancelablePromise<PostAdminAuthLogoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/auth/logout'
        });
    }
    
}

export class AdminWinnerService {
    /**
     * @returns AdminWinnerResponseDto
     * @throws ApiError
     */
    public static getAdminWinner(): CancelablePromise<GetAdminWinnerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/winner'
        });
    }
    
}

export class AdminDebugService {
    /**
     * @param data The data for the request.
     * @param data.identityId
     * @param data.q
     * @param data.page Page number
     * @param data.limit Number of items per page
     * @returns AdminDebugSearchUsersResponseDto List of users
     * @throws ApiError
     */
    public static getAdminDebug(data: GetAdminDebugData): CancelablePromise<GetAdminDebugResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/debug',
            query: {
                q: data.q,
                identityId: data.identityId,
                page: data.page,
                limit: data.limit
            }
        });
    }
    
}

export class AdminDebugPaymentService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static postAdminDebugPayment(): CancelablePromise<PostAdminDebugPaymentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/debug/payment'
        });
    }
    
}

export class AdminCmsService {
    /**
     * @returns AdminCmsPageResponseDto
     * @throws ApiError
     */
    public static getAdminCms(): CancelablePromise<GetAdminCmsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/cms'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminCmsPageResponseDto
     * @throws ApiError
     */
    public static putAdminCms(data: PutAdminCmsData): CancelablePromise<PutAdminCmsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/cms',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class AdminPagesService {
    /**
     * @returns AdminPagesListResponseDto
     * @throws ApiError
     */
    public static getAdminPages(): CancelablePromise<GetAdminPagesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/pages'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminPagesPageResponseDto
     * @throws ApiError
     */
    public static postAdminPages(data: PostAdminPagesData): CancelablePromise<PostAdminPagesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/pages',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @returns AdminPagesPageResponseDto
     * @throws ApiError
     */
    public static getAdminPagesByPageId(data: GetAdminPagesByPageIdData): CancelablePromise<GetAdminPagesByPageIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/pages/{pageId}',
            path: {
                pageId: data.pageId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @param data.requestBody
     * @returns AdminPagesPageResponseDto
     * @throws ApiError
     */
    public static putAdminPagesByPageId(data: PutAdminPagesByPageIdData): CancelablePromise<PutAdminPagesByPageIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/pages/{pageId}',
            path: {
                pageId: data.pageId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @returns CmsPage
     * @throws ApiError
     */
    public static deleteAdminPagesByPageId(data: DeleteAdminPagesByPageIdData): CancelablePromise<DeleteAdminPagesByPageIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/pages/{pageId}',
            path: {
                pageId: data.pageId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @param data.requestBody
     * @returns AdminPagesPageResponseDto
     * @throws ApiError
     */
    public static putAdminPagesByPageIdMetaOpenGraphImageList(data: PutAdminPagesByPageIdMetaOpenGraphImageListData): CancelablePromise<PutAdminPagesByPageIdMetaOpenGraphImageListResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/pages/{pageId}/meta-open-graph-image-list',
            path: {
                pageId: data.pageId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminPagesByPageIdMetaOpenGraphImageList(data: DeleteAdminPagesByPageIdMetaOpenGraphImageListData): CancelablePromise<DeleteAdminPagesByPageIdMetaOpenGraphImageListResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/pages/{pageId}/meta-open-graph-image-list',
            path: {
                pageId: data.pageId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @param data.requestBody
     * @returns AdminPagesPageResponseDto
     * @throws ApiError
     */
    public static putAdminPagesByPageIdMetaTwitterImageList(data: PutAdminPagesByPageIdMetaTwitterImageListData): CancelablePromise<PutAdminPagesByPageIdMetaTwitterImageListResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/pages/{pageId}/meta-twitter-image-list',
            path: {
                pageId: data.pageId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @returns void
     * @throws ApiError
     */
    public static deleteAdminPagesByPageIdMetaTwitterImageList(data: DeleteAdminPagesByPageIdMetaTwitterImageListData): CancelablePromise<DeleteAdminPagesByPageIdMetaTwitterImageListResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/pages/{pageId}/meta-twitter-image-list',
            path: {
                pageId: data.pageId
            }
        });
    }
    
}

export class AdminRoutesService {
    /**
     * @returns AdminPagesRouteResponseDto
     * @throws ApiError
     */
    public static getAdminRoutes(): CancelablePromise<GetAdminRoutesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/routes'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @param data.requestBody
     * @returns AdminPagesRouteResponseDto
     * @throws ApiError
     */
    public static postAdminRoutesByPageIdRoutes(data: PostAdminRoutesByPageIdRoutesData): CancelablePromise<PostAdminRoutesByPageIdRoutesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/routes/{pageId}/routes',
            path: {
                pageId: data.pageId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @param data.routeId
     * @returns AdminPagesRouteResponseDto
     * @throws ApiError
     */
    public static getAdminRoutesByPageIdRoutesByRouteId(data: GetAdminRoutesByPageIdRoutesByRouteIdData): CancelablePromise<GetAdminRoutesByPageIdRoutesByRouteIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/routes/{pageId}/routes/{routeId}',
            path: {
                pageId: data.pageId,
                routeId: data.routeId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @param data.routeId
     * @param data.requestBody
     * @returns AdminPagesRouteResponseDto
     * @throws ApiError
     */
    public static putAdminRoutesByPageIdRoutesByRouteId(data: PutAdminRoutesByPageIdRoutesByRouteIdData): CancelablePromise<PutAdminRoutesByPageIdRoutesByRouteIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/routes/{pageId}/routes/{routeId}',
            path: {
                pageId: data.pageId,
                routeId: data.routeId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.pageId
     * @param data.routeId
     * @returns CmsRoute
     * @throws ApiError
     */
    public static deleteAdminRoutesByPageIdRoutesByRouteId(data: DeleteAdminRoutesByPageIdRoutesByRouteIdData): CancelablePromise<DeleteAdminRoutesByPageIdRoutesByRouteIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/routes/{pageId}/routes/{routeId}',
            path: {
                pageId: data.pageId,
                routeId: data.routeId
            }
        });
    }
    
}

export class AdminComponenti18NService {
    /**
     * @param data The data for the request.
     * @param data.namespaceId
     * @returns AdminComponentI18nListResponseDto
     * @throws ApiError
     */
    public static getAdminComponenti18nByNamespaceIdComponenti18N(data: GetAdminComponenti18nByNamespaceIdComponenti18NData): CancelablePromise<GetAdminComponenti18nByNamespaceIdComponenti18NResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/componenti18n/{namespaceId}/componenti18n',
            path: {
                namespaceId: data.namespaceId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.namespaceId
     * @param data.requestBody
     * @returns AdminComponentI18nResponseDto
     * @throws ApiError
     */
    public static postAdminComponenti18nByNamespaceIdComponenti18N(data: PostAdminComponenti18nByNamespaceIdComponenti18NData): CancelablePromise<PostAdminComponenti18nByNamespaceIdComponenti18NResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/componenti18n/{namespaceId}/componenti18n',
            path: {
                namespaceId: data.namespaceId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.namespaceId
     * @param data.componentI18nId
     * @returns AdminComponentI18nResponseDto
     * @throws ApiError
     */
    public static getAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nId(data: GetAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdData): CancelablePromise<GetAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/componenti18n/{namespaceId}/componenti18n/{componentI18nId}',
            path: {
                namespaceId: data.namespaceId,
                componentI18nId: data.componentI18nId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.namespaceId
     * @param data.componentI18nId
     * @param data.requestBody
     * @returns AdminComponentI18nResponseDto
     * @throws ApiError
     */
    public static putAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nId(data: PutAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdData): CancelablePromise<PutAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/componenti18n/{namespaceId}/componenti18n/{componentI18nId}',
            path: {
                namespaceId: data.namespaceId,
                componentI18nId: data.componentI18nId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.namespaceId
     * @param data.componentI18nId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nId(data: DeleteAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdData): CancelablePromise<DeleteAdminComponenti18nByNamespaceIdComponenti18nByComponentI18nIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/componenti18n/{namespaceId}/componenti18n/{componentI18nId}',
            path: {
                namespaceId: data.namespaceId,
                componentI18nId: data.componentI18nId
            }
        });
    }
    
}

export class AdminNamespaceService {
    /**
     * @returns AdminNamespaceListResponseDto
     * @throws ApiError
     */
    public static getAdminNamespace(): CancelablePromise<GetAdminNamespaceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/namespace'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminNamespaceResponseDto
     * @throws ApiError
     */
    public static postAdminNamespace(data: PostAdminNamespaceData): CancelablePromise<PostAdminNamespaceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/namespace',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.namespaceId
     * @returns AdminNamespaceResponseDto
     * @throws ApiError
     */
    public static getAdminNamespaceByNamespaceId(data: GetAdminNamespaceByNamespaceIdData): CancelablePromise<GetAdminNamespaceByNamespaceIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/namespace/{namespaceId}',
            path: {
                namespaceId: data.namespaceId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.namespaceId
     * @param data.requestBody
     * @returns AdminNamespaceResponseDto
     * @throws ApiError
     */
    public static putAdminNamespaceByNamespaceId(data: PutAdminNamespaceByNamespaceIdData): CancelablePromise<PutAdminNamespaceByNamespaceIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/namespace/{namespaceId}',
            path: {
                namespaceId: data.namespaceId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.namespaceId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminNamespaceByNamespaceId(data: DeleteAdminNamespaceByNamespaceIdData): CancelablePromise<DeleteAdminNamespaceByNamespaceIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/namespace/{namespaceId}',
            path: {
                namespaceId: data.namespaceId
            }
        });
    }
    
}

export class AdminTestimonialService {
    /**
     * @returns AdminTestimonialResponseDto
     * @throws ApiError
     */
    public static getAdminTestimonial(): CancelablePromise<GetAdminTestimonialResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/testimonial'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminTestimonialResponseDto
     * @throws ApiError
     */
    public static postAdminTestimonial(data: PostAdminTestimonialData): CancelablePromise<PostAdminTestimonialResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/testimonial',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns AdminTestimonialResponseDto
     * @throws ApiError
     */
    public static getAdminTestimonialById(data: GetAdminTestimonialByIdData): CancelablePromise<GetAdminTestimonialByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/testimonial/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns AdminTestimonialResponseDto
     * @throws ApiError
     */
    public static putAdminTestimonialById(data: PutAdminTestimonialByIdData): CancelablePromise<PutAdminTestimonialByIdResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/testimonial/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAdminTestimonialById(data: DeleteAdminTestimonialByIdData): CancelablePromise<DeleteAdminTestimonialByIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/testimonial/{id}',
            path: {
                id: data.id
            }
        });
    }
    
}

export class AdminDashboardService {
    /**
     * @param data The data for the request.
     * @param data.days
     * @returns DailyRegistrationsDto
     * @throws ApiError
     */
    public static getAdminDashboardRegistrations(data: GetAdminDashboardRegistrationsData): CancelablePromise<GetAdminDashboardRegistrationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/dashboard/registrations',
            query: {
                days: data.days
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.days
     * @returns DailyActiveUsersDto
     * @throws ApiError
     */
    public static getAdminDashboardActiveUsers(data: GetAdminDashboardActiveUsersData): CancelablePromise<GetAdminDashboardActiveUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/dashboard/active-users',
            query: {
                days: data.days
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.days
     * @param data.missionType
     * @returns DailyMissionCompletionsDto
     * @throws ApiError
     */
    public static getAdminDashboardMissionCompletions(data: GetAdminDashboardMissionCompletionsData): CancelablePromise<GetAdminDashboardMissionCompletionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/dashboard/mission-completions',
            query: {
                days: data.days,
                missionType: data.missionType
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @returns MissionCompletionsPerUserDto
     * @throws ApiError
     */
    public static getAdminDashboardMissionCompletionsPerUser(data: GetAdminDashboardMissionCompletionsPerUserData): CancelablePromise<GetAdminDashboardMissionCompletionsPerUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/dashboard/mission-completions-per-user',
            query: {
                limit: data.limit
            }
        });
    }
    
}

export class AdminToolsService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static getAdminToolsPurgeCache(): CancelablePromise<GetAdminToolsPurgeCacheResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/tools/purge-cache'
        });
    }
    
    /**
     * @returns string
     * @throws ApiError
     */
    public static getAdminToolsMarkTelegramPrcUsers(): CancelablePromise<GetAdminToolsMarkTelegramPrcUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/tools/mark-telegram-prc-users'
        });
    }
    
}

export class AdminToolsSyncTelegramPrcUsersService {
    /**
     * @returns string
     * @throws ApiError
     */
    public static getAdminToolsSyncTelegramPrcUsers(): CancelablePromise<GetAdminToolsSyncTelegramPrcUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/tools/sync-telegram-prc-users'
        });
    }
    
}

export class BhgReverseApiService {
    /**
     * Launch the game
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static postV1BhgReverseApiApiGameLaunch(data: PostV1BhgReverseApiApiGameLaunchData): CancelablePromise<PostV1BhgReverseApiApiGameLaunchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bhg/reverse-api/api/game/launch',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Return the list of games	Called every 1 hour to return the list of games you provide to the brands on our platform.
     * Any new games added will be reflected in the updated list within this 1-hour interval.
     * @param data The data for the request.
     * @param data.xDigitalSignature
     * @param data.requestBody
     * @returns BhgReverseApiGameListResponseDto
     * @throws ApiError
     */
    public static postV1BhgReverseApiApiGameList(data: PostV1BhgReverseApiApiGameListData): CancelablePromise<PostV1BhgReverseApiApiGameListResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bhg/reverse-api/api/game/list',
            headers: {
                'X-Digital-Signature': data.xDigitalSignature
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Return the possible game stake values used to issue free spins	For any requested currencies not recognized by the
     * system, return an empty values array for these currencies instead of returning an error.	NO (depending on provider
     * agreement and specifics)
     * @returns unknown
     * @throws ApiError
     */
    public static postV1BhgReverseApiApiGameStakeValues(): CancelablePromise<PostV1BhgReverseApiApiGameStakeValuesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bhg/reverse-api/api/game/stakeValues'
        });
    }
    
    /**
     * Give free spins.
     * You can include additional data depending on your game specifics and game features.	NO (depending
     * on provider agreement and specifics)
     * @returns unknown
     * @throws ApiError
     */
    public static postV1BhgReverseApiApiGameBonusGive(): CancelablePromise<PostV1BhgReverseApiApiGameBonusGiveResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bhg/reverse-api/api/game/bonus/give'
        });
    }
    
    /**
     * Cancel free spins.
     * Free spins should only be cancelable if the player has not started using them.	NO (depending on
     * provider agreement and specifics)
     * @returns unknown
     * @throws ApiError
     */
    public static postV1BhgReverseApiApiGameBonusCancel(): CancelablePromise<PostV1BhgReverseApiApiGameBonusCancelResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bhg/reverse-api/api/game/bonus/cancel'
        });
    }
    
    /**
     * Return history of a specific game round	Provide historical data only for specific rounds as requested.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns BhgReverseApiRoundHistoryResponseDto
     * @throws ApiError
     */
    public static postV1BhgReverseApiApiGameRoundHistory(data: PostV1BhgReverseApiApiGameRoundHistoryData): CancelablePromise<PostV1BhgReverseApiApiGameRoundHistoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bhg/reverse-api/api/game/round/history',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}